import { push } from 'connected-react-router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAppRoute = () => {
    const dispatch = useDispatch();

    return useCallback((path: string) => dispatch(push(path)), [dispatch]);
};
